<template>
    <div>
        <b-form-group
            id="input-group-1"
            :label="field.label"
            :label-for="`input-${field.label}`"
        >
            <b-form-textarea
                id="textarea"
                :placeholder="field.placeholder"
                rows="3"
                max-rows="3"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
export default {
    props: ['field'],
}
</script>
